import { useQuery } from '@hooks/reactQuery';

import { getAssetAccessRestricted } from '@api/assetAccess';

import { extractQueryParams } from '@utils/common';

import { IAssetAccessRestricted } from '@interfaces/assets/assetAccess';
import { IGetAssetAccessRestrictedDTO } from '@interfaces/assets/dto/assetAccessDTO';

import { EUserRoles } from '@enums/common';

import { ASSET_ACCESS_RESTRICTED } from '@constants/queryKeys';

interface IUseQueryAssetAccessRestrictedReturned {
	assetAccessRestricted: IAssetAccessRestricted[];
	countOfRecords: number;
	isLoadingAssetAccessRestricted: boolean;
}

export const useQueryAssetAccessRestricted = (
	params: IGetAssetAccessRestrictedDTO,
): IUseQueryAssetAccessRestrictedReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ASSET_ACCESS_RESTRICTED, params],
		allowedRoles: [EUserRoles.platformOwnerAdministrator],
		queryFn: extractQueryParams(getAssetAccessRestricted),
		enabled: [!!params.id],
		refetchOnWindowFocus: false,
	});

	return {
		assetAccessRestricted: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingAssetAccessRestricted: isInitialLoading,
	};
};
